import { render, staticRenderFns } from "./MasterGroupClassStudentDetails.vue?vue&type=template&id=1eb667d4"
import script from "./MasterGroupClassStudentDetails.vue?vue&type=script&lang=js"
export * from "./MasterGroupClassStudentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports